import { z } from 'zod'

/** Where a GoHighLevel backfill run is. Mirrors `GhlBackfillStatus` in the Prisma schema (`check:enums`). */
export const GHL_BACKFILL_STATUSES = ['queued', 'running', 'succeeded', 'failed'] as const

export const ghlBackfillStatusSchema = z.enum(GHL_BACKFILL_STATUSES)

export type GhlBackfillStatus = z.infer<typeof ghlBackfillStatusSchema>
